'use client';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { Box, Flex, Heading, Spacer, Text, useRadio } from '@chakra-ui/react';
import cn from 'classnames';
import { ReactNode } from 'react';

import Image from '@/app/_components/Image';
import { PriceFormat } from '@/app/_components/price-format/price-format';
import { getImageLink } from '@/services/link.service';
import { SpecificationsPricesType } from '@/types/new-cars/new-cars.types';
import { directusImageLoader } from '@/utils/loaders';

import Styles from './ModelCard.module.scss';

const ModelCard = (props: {
  value: string;
  children: ReactNode;
  title: string;
  modelDetails: SpecificationsPricesType;
  imageSrc: string | undefined;
  modelName: string;
  imageAlt: string;
}) => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label" className={Styles.modelCardWraper}>
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        className={Styles.modelCard}
        _checked={{
          borderColor: 'green.600',
        }}
        _focus={{
          borderColor: 'green.600',
        }}
      >
        <Box className={Styles.modelCardImage}>
          <Image
            src={getImageLink(props?.imageSrc ?? null) ?? ''}
            loader={directusImageLoader}
            width={232}
            height={140}
            alt={props?.imageAlt}
            title={props?.imageAlt}
          />
        </Box>
        <Box className={Styles.modelCardContent}>
          <Box>
            <Text fontSize="xs">{props?.modelName}</Text>
            <Flex gap={2}>
              <Box className={Styles.headingElement}>
                <Heading as="h2" className={Styles.titleLg}>
                  {props?.modelDetails?.title}
                </Heading>
              </Box>

              <Spacer />

              <Box className={Styles.modelCardRadio} />
              <Box className={Styles.modelCardRadioChecked}>
                <CheckCircleIcon color="green.600" />
              </Box>
            </Flex>
          </Box>
          <Box>
            <Text fontSize="xs">Price</Text>
            <Box className={Styles.headingElement}>
              <Heading as="h3" className={Styles.titleXl}>
                <PriceFormat prefix="R" value={props?.modelDetails?.price} />
              </Heading>
            </Box>
          </Box>
          <Box>
            <Text fontSize="xs">Fuel Type</Text>
            <Box className={Styles.headingElement}>
              <Heading as="h3" className={Styles.titleXl}>
                {props?.modelDetails?.fuel_type}
              </Heading>
            </Box>
          </Box>
          {/* <Box>
            <Text fontSize="xs">Fuel Consumption</Text>
            <Box className={Styles.headingElement}>
              <Heading as="h3" className={Styles.titleXl}>
                {props?.modelDetails?.fuel_consumption}
              </Heading>
            </Box>
          </Box> */}
          {props?.modelDetails &&
            props?.modelDetails?.feature?.map((fea, index) => {
              return (
                <Box key={index}>
                  <Text fontSize="xs">{fea?.title}</Text>
                  <Box className={Styles.headingElement}>
                    <Heading
                      as="h3"
                      className={cn(Styles.titleXl, Styles.fwNormal)}
                    >
                      {fea?.description}
                    </Heading>
                  </Box>
                </Box>
              );
            })}
        </Box>
      </Box>
    </Box>
  );
};

export default ModelCard;
